module.exports = __webpack_public_path__ + "img/green-tick-icon.3b563a90.svg";